// extracted by mini-css-extract-plugin
module.exports = {"commonSelect":"AdminSelect_commonSelect__xDF-n","invalidFeedback":"AdminSelect_invalidFeedback__2DbyT","addNew":"AdminSelect_addNew__hoOU-"};